export default {
  OK: "Baik",
  CLOSE: "Akun telah ditutup!",
  BLOCK: "Akun telah diblokir!",
  FREEZE: "Akun telah dibekukan!",
  SUSPEND: "Akun Anda telah berubah menjadi hanya LIHAT.",
  passwordRequired: "Diperlukan kata sandi!",
  usernameRequired: "Nama pengguna harus diisi!",
  incompletedRequest: "Something goes wrong...",

  session_not_exists: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  session_expired: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  invalidSession: "Session expired! Please login again to continue...",
  accountIdRequired: "Sesi berakhir! Silakan masuk lagi untuk melanjutkan...",
  NoUserAccessRight: "Izin ditolak! Silakan hubungi upline untuk melanjutkan ...",
  account_not_exists: "Kata sandi salah",
  invalid_password: "Kata sandi salah",
  secondary_account_exists: "Nama panggilan Anda sudah dibuat.",
  systemError: "Kesalahan Sistem Internal",
  new_login_id_exists: "Nama panggilan tidak valid, cobalah untuk mengatur nama panggilan yang berbeda.",
  loginLimit: "Anda terlalu sering masuk, silakan coba lagi setelah 1 menit...",
  requestLimit: "You have request too frequent.",
  unableToGetBalanceAtTheMoment: "Kesalahan server internet",
  oddsDisplayInvalid: "Odds Is Updating...",
  oddsIsUpdating: "Odds Is Updating...",
  atLeastTwoMatchToBetParlay: "Setidaknya mencampur dua pertandingan untuk bertaruh dalam parlay",
  atLeastThreeMatchToBetParlay: "Setidaknya mencampur tiga pertandingan untuk bertaruh dalam parlay",
  
  duplicate_debit_record: "Odds Is Updating...",

  insufficient_balance: "Saldo tidak mencukupi",
  betOverMaxPerMatch: "Taruhan Anda melebihi taruhan maks",
  betOverMax: "Your stake exceeds the max stake.",
  betOverMaxBet: "Your stake exceeds the max stake.",
  betLowerMin: "Your stake less than the min stake.",

  loginFailed: "Gagal masuk, silakan coba lagi nanti...",
  requestFailed: "Koneksi Anda tidak stabil, harap periksa koneksi internet Anda dan coba lagi.",
  requestPending: "Permintaan tertunda...",

  close: "Akun ditutup! Silakan hubungi upline Anda untuk melanjutkan...",
  suspend: "Akun ditangguhkan! Silakan hubungi upline Anda untuk melanjutkan...",
  freeze: "Akun dibekukan! Silakan hubungi upline Anda untuk melanjutkan...",

  alphaNumOnly: "Hanya alfanumerik",

  // vuelidate
  isRequired: "Silakan masuk {fname}.",
  isMinValue: "{fname} harus memiliki minimal {fvalue}.",
  isMaxValue: "{fname} harus kurang dari atau sama dengan {fvalue}.",
  isMinLength: "{fname} harus memiliki setidaknya {fvalue} karakter",
  isMaxLength: "{fname} harus kurang dari atau sama dengan {fvalue}",
  isAlpha: "{fname} hanya menerima alfabet",
  isAlphaNum: "{fname} hanya menerima alfanumerik",
  isNumeric: "{fname} hanya menerima angka",
  isEmail: "{fname} hanya menerima alamat email yang valid",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang valid",
  isSameAs: "{fname} harus sama dengan {fname2}.",
  isUrl: "{fname} hanya menerima URL",
  containAlphaNum: "{fname} harus memiliki setidaknya satu alfabet dan satu nomor.",
  selectOption: "Silakan pilih {fname}",
  notSameAs: "{fname} dan {fname2} tidak bisa sama.",

  currPasswordRequired: "Kata sandi saat ini diperlukan",
  newPasswordRequired: "Diperlukan kata sandi baru!",
  confirmNewPasswordRequired: "Diperlukan kata sandi baru!",
  passwordsNotMatch: "Sandi tidak cocok!",
  nickNameRequired: "Nama panggilan wajib diisi!",

  startDateRequired: "Diperlukan tanggal mulai!",
  endDateRequired: "Tanggal akhir diperlukan!",
  pageSizeRequired: "Diperlukan ukuran halaman!",
  pageNumberRequired: "Nomor halaman wajib diisi!",
  sportsTypeRequired: "Jenis olahraga diperlukan!",

  workingDateRequired: "Tanggal kerja diperlukan!",
  leagueIdRequired: "ID Liga diperlukan!",
  isOutrightRequired: "Is outright is required!",

  maxParlayTicket: "Raih tiket maksimum per parlay!",
  matchHide: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  matchNotAllowBet: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  matchNotActive: "Pasar ini tidak tersedia, silakan coba pasar lain.",
  invalidBets: "Pasar ini tidak tersedia, silakan coba pasar lain.",

  invalidOddsBall: "Odds Is Updating...",
  selectLeague: "Silakan pilih setidaknya 1 liga",
  liveCasinoDisabled: "Live Casino Dinonaktifkan",
  slotDisabled: "Slot Dinonaktifkan",
  lotteryDisabled: "Lottery Dinonaktifkan",
  MiniGameDisabled: "Mini Game Dinonaktifkan",
  EsportsDisabled: "E-Sports Game Dinonaktifkan",
  currencyNotSupported: "Mata uang tidak didukung",
  game_maintenance: "Game is under maintenance.",
  forbiddenAccess: "Akses Terlarang",
  invalidCurrency: "Mata uang tidak valid untuk bertaruh",
  connectionFailed: "Gagal menghubungkan sistem dompet.",

  //tournament
  login_id_not_exists: "Login tidak valid, silakan coba login kembali.",
  noMatchSelected: "Silakan pilih setidaknya 1 pertandingan.",
  invalidRoomRate: "Tarif kamar tidak valid.",
  invalidRoomLimit: "Batas kamar tidak valid.",
  invalidRoomPassword: "Kode PIN tidak valid. Kode PIN harus berisi 6 angka.",
  invalidPassword: "Password tidak valid",
  roomPasswordRequired: "Kode PIN dibutuhkan.",
  minMatch: "Minimum 3 pertandingan yang dipilih.",
  maxMatch: "Maksimum {max} pertandingan yang dipilih.",
  roomIdRequired: "ID kamar dibutuhkan.",
  roomTypeRequired: "Tipe kamar dibutuhkan.",
  sessionTokenRequired: "Token sesi dibutuhkan.",
  matchDateRequired: "Tanggal pertandingan dibutuhkan.",
  matchRequired: "Pertandingan dibutuhkan.",
  roomLimitRequired: "Batas kamar dibutuhkan.",
  roomRateRequired: "Tarif kamar dibutuhkan.",
  minRoomRate: "Biaya masuk harus sama atau lebih besar dari 10.",
  maxRoomRate: "Biaya masuk harus sama atau kurang dari 1000.",
  minRoomLimit: "Jumlah pemain harus sama atau lebih besar dari 3.",
  maxRoomLimit: "Jumlah pemain harus sama atau kurang dari 30.",
  invalidRoomType: "Tipe kamar tidak valid.",
  invalidMatch: "Pertandingan tidak valid.",
  dataError: "Kesalahan data",
  memberExists: "Anggota sudah ada.",
  invalidMember: "Anggota tidak valid.",
  invalidleague: "Liga tidak valid.",
  "createRoomFailed-1": "Gagal membuat kamar 1.",
  "createRoomFailed-2": "Gagal membuat kamar 2.",
  "createRoomFailed-3": "Gagal membuat kamar 3.",
  invalidOperator: "Operator tidak valid.",
  roomFull: "Kamar sudah penuh.",
  memberExists: "Anggota sudah ada.",
  "joinFailed-1": "Gagal bergabung dengan kamar 1.",
  "joinFailed-2": "Gagal bergabung dengan kamar 2.",
  IPJoinedBefore: "IP sudah bergabung sebelumnya.",
  memberJoinedBefore: "Anda sudah bergabung sebelumnya, harap dicatat bahwa ruang bebas publik hanya bisa bergabung sekali.",
  roomNotExists: "Kamar tidak ada.",
  roomIsPublicFree: "Kamar adalah bebas publik.",
  roomEndedOrCancelled: "Ruangan berakhir atau dibatalkan.",
  roomEnded: "Ruangan sudah berakhir.",

  matchLowerMin: "Terjadi kesalahan match lower min.",
  matchOverMax: "Terjadi kesalahan match over max.",
  pointsOverLimit: "Terjadi kesalahan poin melebihi batas.",
  roomOverMax: "Terjadi kesalahan ruangan over max.",
  invalidRoom: "Ruangan tidak valid.",
  roomLimitOverMax: "Terjadi kesalahan batas ruangan over max.",
  rateLowerMin: "Terjadi kesalahan rate lower min.",
  rateOverMax: "Terjadi kesalahan rate over max.",

  liveMatchNotAllowed: "Pertandingan live tidak diizinkan.",
  roomLimitLowerMin: "Terjadi kesalahan batas ruangan lower min.",
  roomClosed: "Ruangan ditutup.",
  tournamentLeagueExists: "Liga turnamen sudah ada.",
  roomExists: "Tidak diizinkan untuk membuat lebih dari 1 ruangan privat.",
  roomExists: "Tidak diizinkan untuk membuat lebih dari 1 ruangan privat.",
  betExists: "Taruhan sudah ada.",
  roomClosedNotAllowed: "Ruangan ditutup tidak diizinkan.",
  tournamentMatchExists: "Pertandingan turnamen sudah ada.",
  account_id_required: "ID akun dibutuhkan.",
  agent_comm_rate_required: "Rate komisi agen dibutuhkan.",
  agent_id_required: "ID agen dibutuhkan.",
  bet_amount_required: "Jumlah taruhan dibutuhkan.",
  bet_id_required: "ID taruhan dibutuhkan.",
  credit_amount_required: "Jumlah kredit dibutuhkan.",
  currency_required: "Mata uang dibutuhkan.",
  debit_amount_required: "Jumlah debit dibutuhkan.",
  duplicate_credit_record: "Rekaman kredit duplikat.",
  master_comm_rate_required: "Rate komisi master dibutuhkan.",
  master_id_required: "ID master dibutuhkan.",
  member_id_required: "ID member dibutuhkan.",
  member_wallet_not_exists: "Dompet member tidak ada.",
  permission_denied: "Izin ditolak.",
  rate_required: "Rate dibutuhkan.",
  result_exists: "Hasil sudah ada.",
  room_id_required: "ID ruangan dibutuhkan.",
  s_senior_comm_rate_required: "Rate komisi super senior dibutuhkan.",
  s_senior_id_required: "ID super senior dibutuhkan.",
  senior_comm_rate_required: "Rate komisi senior dibutuhkan.",
  senior_id_dibutuhkan: "ID senior dibutuhkan.",
  shareholder_comm_rate_dibutuhkan: "Tingkat komisi pemegang saham dibutuhkan.",
  shareholder_id_dibutuhkan: "ID pemegang saham dibutuhkan.",
  transfer_id_dibutuhkan: "ID transfer dibutuhkan.",
  jumlahTaruhanMinimum: "Kesalahan jumlah taruhan minimum terjadi.",
  tournamentDisabled: "Turnamen dinonaktifkan, harap periksa kontak upline Anda.",
  // tournamentDisabled: "Turnamen akan segera hadir. Harap tetap disini!",
  marketTypeRequired: "Tipe Pasar diperlukan.",
  invalidMarketType: "Tipe pasar yang diberikan tidak valid.",
  marketTypeChanged: "Bet Slip telah dihapus karena perubahan tipe pasar.<br />Silakan pilih kembali dari pasar.",
  changeStakeMin: "Masukan nilai stake telah diubah karena batas MIN.",
  changeStakeMax: "Masukan nilai stake telah diubah karena batas MAX.",
  betNotExists: "Silakan pasang taruhan yang valid untuk mengikuti turnamen.",
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
